import layout1Settings from './Layout1/Layout1Settings'
import { themes } from '../MainTheme/initThemes'


export const MainLayoutSettings = {
    activeLayout: 'layout1', // layout1, layout2
    activeTheme: 'blue', // View all valid theme colors inside MainTheme/themeColors.js
    perfectScrollbar: false,

    themes: themes,
    layout1Settings, // open Layout1/Layout1Settings.js

    secondarySidebar: {
        show: true,
        open: false,
        theme: 'slateDark1', // View all valid theme colors inside MainTheme/themeColors.js
    },
    // Footer options
    footer: {
        show: false,
        fixed: false,
        theme: 'slateDark1', // View all valid theme colors inside MainTheme/themeColors.js
    },
}
